import { Typography } from "@mui/material";

/**
 * Builds the confirmation dialog title based on the action type.
 *
 * @param {Object|null} data - Dialog data object
 * @param {boolean} [data.isAssignment] - Whether this is an assignment (true) or unmapping (false)
 * @returns {string} The dialog title
 */
export const getConfirmationTitle = (data) => {
  if (!data) return "";
  return data.isAssignment ? "Confirm Assignment" : "Confirm Unmapping";
};

/**
 * Builds the confirmation dialog content (JSX) based on the action data.
 *
 * @param {Object|null} data - Dialog data object
 * @param {boolean} [data.isAssignment] - Whether this is an assignment (true) or unmapping (false)
 * @param {Object} [data.ud] - Universal Descriptor object
 * @param {string} [data.ud.UD] - Universal Descriptor name
 * @param {number} [data.count] - Number of tags affected
 * @param {string} [data.tagName] - Optional tag name to display
 * @param {string} [data.tenantId] - Optional tenant ID to specify scopes
 * @returns {JSX.Element|null} The dialog content as JSX
 */
export const getConfirmationContent = (data, getTenantName) => {
  if (!data) return null;
  return (
    <>
      <Typography>
        {data.isAssignment ? (
          <>
            Do you want to assign the Universal Descriptor{" "}
            <strong>{data.ud?.UD || ""}</strong> to{" "}
            <strong>{data.count?.toLocaleString() || 0}</strong> tags?
          </>
        ) : (
          <>
            Do you want to unmap the Universal Descriptor{" "}
            <strong>{data.ud?.UD || ""}</strong> from{" "}
            <strong>{data.count?.toLocaleString() || 0}</strong> tags?
          </>
        )}
        <br></br>
        This change will apply to{" "}
        <strong>
          {data.tenantId
            ? `the ${getTenantName(data.tenantId)} Tenant`
            : "all tenants"}
        </strong>
        .
      </Typography>
      {data.tagName && (
        <Typography variant='body2' sx={{ mt: 1, color: "text.secondary" }}>
          Tag Name: <strong>{data.tagName}</strong>
        </Typography>
      )}
    </>
  );
};
